import { Polygon } from "@react-google-maps/api";
import { useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setBoundaryDepth, setSelectedTown } from "../../features/boundaries/boundariesSlice";
import CustomInfoWindow from "./CustomInfoWindow";

// Polygon seçenekleri
const options = {
  strokeColor: "#010691",
  strokeOpacity: 1,
  strokeWeight: 1,
  fillColor: "#010691",
  fillOpacity: 0.15,
  clickable: true,
  zIndex: 5,
};

const hoveredOptions = {
  strokeColor: "#010691",
  strokeOpacity: 1,
  strokeWeight: 1,
  fillColor: "#010691",
  fillOpacity: 0.4,
  clickable: true,
  zIndex: 5,
};

const activeOptions = {
  strokeColor: "#010691",
  strokeOpacity: 1,
  strokeWeight: 1,
  fillColor: "transparent",
  clickable: true,
  zIndex: 5,
};

/* Dinamik SVG oluşturucu: Metne göre genişliği ayarlar */
const getDynamicWidthSVG = (text) => {
  if (!text) return null;
  const textLength = text.length * 8;
  const width = textLength + 20;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="40">
    <rect x="0" y="0" width="${width}" height="40" rx="8" ry="8" fill="rgba(0, 0, 0, 1)" />
    <text x="${width / 2}" y="25" font-size="12" fill="white" font-family="Arial" text-anchor="middle">${text}</text>
  </svg>`;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    width,
    height: 40,
    scaledSize: new window.google.maps.Size(width, 40),
  };
};

const TownsBoundaries = () => {
  const [mousePosition, setMousePosition] = useState(null);
  const [hoveredTown, setHoveredTown] = useState(null);
  const dispatch = useDispatch();
  const { townsBoundariesList, selectedTown, selectedCity } = useSelector((state) => state.boundaries);

  const handleMouseOver = useCallback((item) => {
    setHoveredTown({ townId: item.townId, id: item.id, townName: item.townName });
  }, []);

  const handleMouseOut = useCallback(() => {
    setHoveredTown(null);
  }, []);

  const handleMouseMove = useCallback((event) => {
    setMousePosition({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  }, []);

  const handleClick = useCallback(
    (item) => {
      dispatch(
        setSelectedTown({
          townId: item.townId,
          id: item.id,
          townName: item.townName,
          centerCoords: item.centerCoords,
          locatedCityId: item.locatedCityId,
        })
      );
      setHoveredTown(null)
      dispatch(setBoundaryDepth(4))
    },
    [dispatch]
  );

  if (!townsBoundariesList || townsBoundariesList.length < 1) return null;

  return (
    <>
      {townsBoundariesList.map((item) =>
        item.coords.map((boundary, index) => {
          const isHovered = hoveredTown?.townId === item.townId;
          const isActive =
            (selectedCity?.cityId === item.locatedCityId && selectedTown?.townId === item.townId) ||
            !selectedTown?.townId;
          const polygonOptions = isHovered ? hoveredOptions : isActive ? activeOptions : options;
          return (
            <Polygon
              key={`${item.townId}-${index}`}
              path={boundary}
              options={polygonOptions}
              onClick={() => handleClick(item)}
              onMouseOver={() => handleMouseOver(item)}
              onMouseOut={handleMouseOut}
              onMouseMove={(event) => handleMouseMove(event)}
            />
          );
        })
      )}
      {mousePosition && hoveredTown && (
        <CustomInfoWindow
          position={{ lat: mousePosition.lat + 0.01, lng: mousePosition.lng }}
          content={
            (() => {
              const svgIcon = getDynamicWidthSVG(hoveredTown.townName);
              return svgIcon ? (
                <img
                  src={svgIcon.url}
                  alt={hoveredTown.townName}
                  style={{ width: svgIcon.width, height: svgIcon.height, display: "block" }}
                />
              ) : null;
            })()
          }
        />
      )}
    </>
  );
};

export default TownsBoundaries;
